export default __webpack_public_path__ + "static/media/rubblar_icon.234018fb.png";